import { defineMessages } from "react-intl";

const messages = defineMessages({
    downloadCSV: {
        id: "downloadCSV",
    },
});

export default messages;
